module.exports = __webpack_public_path__ + "img/new-home-page-guide-drawer-illustration-en2.1b2215f.png";